/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type ScoreByDeviceTagChart_answersReport = {|
  +scoreByDeviceTag: ?$ReadOnlyArray<?{|
    +tag: ?string;
    +score: ?number;
    +count: ?number;
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ScoreByDeviceTagChart_answersReport",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "ScoreByDeviceTag",
      "name": "scoreByDeviceTag",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tag",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "score",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AnswersReport"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/ScoreByDeviceTagChart/__generated__/ScoreByDeviceTagChart_answersReport.graphql.js